import { Box, Button } from '@mui/material'
import { Loading } from '../components/ui/Loading'
import { useMutation } from '@tanstack/react-query'
import { useEffect } from 'react'
import { useAuth } from '@clerk/clerk-react'
import { useRequestInterceptor } from '../api/config'
import { useNavigate } from 'react-router-dom'
import { Error } from '../components/ui/Error'
import { UserMngmt } from '../api/UserMngmt'

export const PostSignup = () => {
    let navigate = useNavigate()
    const { getToken } = useAuth()
    useRequestInterceptor({ getToken })

    const {
        isError,
        reset,
        mutate: createUser,
    } = useMutation({
        mutationKey: ['post-signup'],
        mutationFn: UserMngmt.createUser,
        onSuccess: () => {
            navigate('/merchant/onboarding')
        },
    })

    useEffect(() => {
        createUser()

        return () => {
            reset()
        }
    }, [createUser, reset])

    const container = (child) => (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                pt: '6rem',
                alignItems: 'center',
                width: '100%',
                gap: '1.5rem',
            }}
        >
            {child}
        </Box>
    )

    if (isError) {
        return (
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    pt: '6rem',
                    alignItems: 'center',
                    width: '100%',
                    gap: '1.5rem',
                }}
            >
                <Error message={'Something went wrong...'} />
                <Button variant="contained" onClick={createUser}>
                    Retry
                </Button>
            </Box>
        )
    } else {
        return container(<Loading />)
    }
}
